export type HomepageHeroSlideKind = 'brand' | 'image' | 'solid';

export interface HomepageHeroPillLink {
  label: string;
  to: string;
  accent?: boolean;
}

/** Admin-editable homepage carousel slide (stored in PlatformSettings.homepageHeroJson). */
export interface HomepageHeroSlideConfig {
  id: string;
  enabled?: boolean;
  sortOrder?: number;
  kind?: HomepageHeroSlideKind;
  imageUrl?: string;
  bgClass?: string;
  overlayColor?: string;
  badge?: string;
  headline: string;
  /** Secondary line on brand-layout slides (e.g. “Shop local. Ship island-wide.”) */
  tagline?: string;
  sub?: string;
  ctaLabel: string;
  ctaTo: string;
  pills?: HomepageHeroPillLink[];
  /** Brand slides: append live shop category quick links when true. */
  includeCategoryPills?: boolean;
}

export interface HomepageHeroConfig {
  slides: HomepageHeroSlideConfig[];
  /** Autoplay interval in ms (default 5500). */
  intervalMs?: number;
}

export const DEFAULT_HERO_INTERVAL_MS = 5500;
